import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/admin/info/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/dashboard/admin/info/"!</div>
}
